


export function CircularImage({ src , className, onMouseEnter, onMouseLeave}: { src: string, className?: string, onMouseEnter?: any, onMouseLeave?: any }) {
    return (<img onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={`w-full rounded-full object-contain ${className}`} src={src} />)
}